import { useEffect, useState } from 'react';

const useResetPasswordRequest = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const resetPasswordRequest = async (email) => {
        setIsLoading(true);
        setError(null);
        setMessage(null);

        try {
            const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/password-reset-request`;
            
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Network response was not ok: ${response.status} - ${errorText}`);
            }

            const data = await response.json();
            setMessage(data.message);
        } catch (error) {
            setError(error.message || 'An error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    const resetPassword = async (token, newPassword, confirmPassword) => {
        setIsLoading(true);
        setError(null);
        setMessage(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/password-reset-confirm`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, newPassword, confirmPassword }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setMessage(data.message);
        } catch (error) {
            setError(error.message || 'An error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    return { isLoading, error, message, resetPasswordRequest, resetPassword };
};

export default useResetPasswordRequest;

